<mat-card appearance="outlined" [style.width]="width" class="se-ui-combo-content mat-card-shadow">
    <form tabindex="0" class="fix-editor" [formGroup]='comboForm'>
        <mat-form-field class="ag-row fix-mat-form combo-cell-editor" hintLabel="{{ 'se-ui-datagrid_combo_cell_editor_hint' | translate }}">
            <mat-select #comboInput
                        tabindex="0"
                        panelClass="ag-custom-component-popup"
                        formControlName='selection'
                        [compareWith]="compareWithFn"
                        [errorStateMatcher]="matcher"
                        [multiple]="multi"
                        (openedChange)="_onOpenedChange($event)"
                        ngDefaultControl
                        (keydown)="onKeydown($event)"
                        >
                <mat-option *ngFor="let item of dataSource" [value]="valueFieldName ? item[valueFieldName] : item" (keydown)="onKeydown($event)">
                    {{ viewValueFieldName ? item[viewValueFieldName] : item }}
                </mat-option>
            </mat-select>
            <button class="icon-button-close se-button-no-ripple" *ngIf="isResettable && !multi && !required" matSuffix mat-icon-button aria-label="Clear"
                    (click)="_onCleanCombo($event)">
                <mat-icon class="icon-close">close</mat-icon>
            </button>
            <mat-error *ngIf="comboForm.hasError('required')">
                {{ 'se-ui-datagrid_required_value_constraint' | translate }}
            </mat-error>
        </mat-form-field>
    </form>
</mat-card>
